import {FunctionComponent} from "react";
import ExportingDialog from "./exporting";
import PreviewImagesDialog from "./preview-images";
import SubmitTicketDialog from "./submit-ticket";
import ShareLinkDialog from "./share-link";


const BizkeytechDialogs: FunctionComponent = () => {
    
    return (
        <>
            <ExportingDialog/>
            <ShareLinkDialog/>
            <PreviewImagesDialog/>
            <SubmitTicketDialog/>
        </>
    );
}


export default BizkeytechDialogs;
